module.exports = __webpack_public_path__ + "media/images/play_alternate-9bfc98a6.png";